import classes from './Footer.module.css';
import logo from '../../assets/logo.png'
import {useTranslation} from "react-i18next";


const Footer = () => {
    const {t} = useTranslation()
    return <footer className={classes.footer_container} id='footer_id' style={{display: 'none'}}>
        <div className={classes.footer}>
            <img src={logo} alt="fe"/>
            <ul>
                <li style={{color: "#668cff"}}>{t("ADDRESS")}</li>
                <li> {t("AdressSt")}</li>
                <li> {t("AdressTbilisi")}</li>
            </ul>
            <ul>
                <li style={{color: "#668cff"}}>{t("Contacts")}</li>
                <li><a href="tel:995599536196" style={{color: 'white'}}>+995 599 536196</a></li>
                <li><a href="tel:995598202526" style={{color: 'white'}}>+995598202526</a></li>
                <li><a href="mailto:info@futureworlds.ge" style={{color: 'white'}}> info@futureworlds.ge</a></li>
            </ul>
        </div>
    </footer>
}
export default Footer;